import ReminderBS from './ReminderBS.jsx';

export default ReminderBS;